import $http from '@axios'

export default {
  namespaced: true,
  state: {
    formPayload: {
      name: '',
      description: '',
      logo: '',
    },
    dataRetur: {},
    saveDiscount: false,
  },
  getters: {},
  mutations: {
    setSaveDiscount(state, value) {
      state.saveDiscount = value
    },
    setFormPayload(state, value) {
      state.formPayload = value
    },
    setDataRetur(state, value) {
      state.dataRetur = value
    },
  },
  actions: {
    getData(context, { params, uuid }) {
      return new Promise((resolve, reject) => {
        $http.get(`/order/${uuid || ''}`, { params })
          .then(result => {
            resolve(result)
          }).catch(err => {
            reject(err)
          })
      })
    },
    postData(context, { payload, uuid }) {
      return new Promise((resolve, reject) => {
        $http.post(`/order/${uuid || ''}`, payload)
          .then(result => {
            resolve(result)
          }).catch(err => {
            reject(err)
          })
      })
    },
    deleteData(context, { payload, uuid }) {
      return new Promise((resolve, reject) => {
        $http.post(`/order/${uuid || ''}`, payload)
          .then(result => {
            resolve(result)
          }).catch(err => {
            reject(err)
          })
      })
    },
  },
}
